import * as React from 'react';

import styles from './ChatWindowLayout.css';

type TProps = {
  backgroundImageUrl: string | null;
  headerNode: React.ReactNode;
  bodyNode: React.ReactNode;
  footerNode: React.ReactNode;
};

export const ChatWindowLayout: React.FC<TProps> = ({ backgroundImageUrl, headerNode, bodyNode, footerNode }) => {
  return (
    <div
      className={styles['container']}
      style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined }}
    >
      {headerNode}
      <div className={styles['body']}>{bodyNode}</div>
      {footerNode}
    </div>
  );
};
